// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/Components/UploadButton/Assets/romanian-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/Components/UploadButton/Assets/english-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/Assets/chessHeader.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --romanian-flag-icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --english-flag-icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --vertical-padding-button: 8px;
}

body {
  overflow: auto !important;
}

body.modal-open {
  overflow: hidden !important;
}

::-webkit-scrollbar {
  width: 7px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 20%;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  overflow: hidden !important;
}

.App {
  text-align: center;
  background: #EEE;
}

.background-white {
  background: #FFF;
}

.background-gray {
  background: #EEE;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.p-16 {
  padding: 200px;
}

.rounded-image {
  width: 40px;
  height: 40px;
  border-radius: 100%;
}

.disabledButton {
  pointer-events: none;
  border: 2px solid #BABABA!important;
  background: #FFF!important;
  color: #BABABA!important;
}

.button-upload {
  display: flex;
  border-style: hidden;
  width: 100%;
  padding: var(--vertical-padding-button) 24px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-shrink: 0;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  border-radius: 100px;
}

.button-upload-upload{
  justify-content: center;
  font-weight: 400;
  background: #C7D2FF;
  color: #214BFF;
}

.button-upload-upload:hover{
  background: #93A8FF;
  color: #002AE0;
}

.button-upload-view {
  font-weight: 600;
  color: #214BFF;
  border: 2px solid #214BFF;
  background: #FFF;
}

.button-upload-view:hover {
  text-decoration-line: underline;
}

.x-button {
  background: none;
  border: none;
  border-radius: 9999px;
}

.language-button {
  display: flex;
  height: 48px;
  padding: var(--vertical-padding-button) 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  border: 2px solid #EEE;
  background: #FFF;
  color: #23233D;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 43px;
  letter-spacing: -0.16px;
}


.selector {
  height: 45px;
  color: #EF6C00;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  border-radius: 50px;
  line-height: 160%;
  flex-wrap: nowrap;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
  overflow: hidden;
}

.selector-unselected:hover {
  cursor: pointer;
  font-weight: 600 ;
  border: 2px solid #EF6C00;
}

.selector-unselected {
  font-weight: 400;
  border: 1px solid #EF6C00;
  background: var(--Main-colors-White, #FFF);
}

.selector-selected{
  background: #FBDABF;
}

.columnNameBox {
  padding: 10px;
  align-items: center;
  min-width: 100px;
  gap: 10px;
  color: #4D4D68;
  font-family: Poppins, sans-serif;
  font-size: 20px;
  font-weight: 400;
}

.footer-button{
  display: flex;
  height: 56px;
  min-width: 200px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  color: #FFF;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 43px; /* 268.75% */
  border-radius: 100px;
}

/*Deals with footer button resizing*/
@media screen and (max-width: 768px) {
  .footer-button {
    width: 100%;
  }
  .container-footer-button{
    width: 100%;
  }
  .container-footer {
    flex-direction: column;
  }
}

.footer-button-pdf {
  border-radius: 100px;
  background: #214BFF;
}

.footer-button-pdf:hover {
  background: #0028D4;
}

.footer-button-reimport {
  border: 2px solid #0028D4;
  background: #FFF;
  color: #0028D4;
}

.footer-button-reimport:hover {
  color: #FFF;
  background: #0028D4;
}

.footer-button-reimport-disabled {
  border: 2px solid #BABABA;
  background: #FFF;
  color: #BABABA;
}

.interaction-button {
  display: flex;
  width: 248px;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 100px;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 43px; /* 268.75% */
  border: 2px solid #214BFF;
  background: #FFF;
  color: #214BFF;
}

.interaction-button:hover {
  color: #FFF;
  background: #214BFF;
  border-style: hidden;
}

.action-button {
  display: flex;
  height: 48px;
  padding: var(--vertical-padding-button) 16px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #FFF;
  font-family: Montserrat, sans-serif;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
  border-radius: 100px;
  border-style: hidden;
}
.action-button-save {
  background: #214BFF;
}
.action-button-save:hover {
  background: #0028D4;
}

.action-button-cancel {
  background: #FF4047;
}

.action-button-cancel:hover{
  background: #C70F16;
}

.login-button-logout {
  display: inline-flex;
  height: 48px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  color: #FFF;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 43px; /* 268.75% */
  border-radius: 100px;
  background: #214BFF;
}

.login-button-logout:hover {
  background: #0028D4;
}

.edit-button {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 100px;
  border: 1px solid #EEE;
  background: #FFF;
  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);
  color: #214BFF;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
}

.edit-button:hover {
  background: #214BFF;
  border-style: hidden;
  color: #FFF;
}

.modal-container {
  display: flex;
  width: 35vw;
  padding: 24px 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  border-radius: 32px;
  background: #FFF;
  box-shadow: 0 8px 16px 0 rgba(17, 17, 17, 0.32);
}

.modal-container-upload-area {
  display: flex;
  width: 94%;
  height: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 3px dashed #D5D5D5;
}

.modal-container-header{ 
  display: flex;
  width: 99%;
  padding: 0 2rem;
  justify-content: space-between;
  align-items: center;
  color: #23233D;
  font-family: Poppins, sans-serif;
  font-size: 28px;
  font-weight: 600;
}

@media screen and (max-width: 1280px) {
  .modal-container {
    width: 100%;
  }
  .modal-container-upload {
    width: 90%;
  }
  .modal-container-header {
    display: hidden;
    border-style: hidden;
    box-shadow: none;
    border: 0;
  }
}

/* To prevent weird outline from reactstrap modal. Overriding */
div.modal-content, div.modal-main{
  border-style: hidden;
  box-shadow: none;
}
  div.modal-content{
    background: none;
  }

.modal-container-drag-drop-info-second-container{
  display: flex;
  width: 248px;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.modal-container-drag-drop-footer-text{
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--Neutrals-Neutral-300, #6D6D82);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 125%; /* 17.5px */
}

.modal-main{
  min-width: max-content;
}

.modal-dialog{
  display:flex;
  align-items: center;
  justify-content: center;
  position: relative!important;
}

.modal-editor-container {
  display: flex;
  flex-direction: column;
  width: 60vw;
  height: auto;
  padding: 12px;
  align-items: center;
  border-radius: 32px;
  background: #FFF;
  box-shadow: 0 8px 16px 0 rgba(17, 17, 17, 0.32);
}

.image-editor-container-buttons-container{
  display: flex;
  width: 100%;
  max-height:-moz-fit-content ;
  max-height:fit-content ;
  padding: 0 24px 12px 24px;
  justify-content: space-between;
  position: absolute;
}

.image-editor-container{
  display: flex;
  justify-content: center;
  width: 100%;
  height: 70vh;
  border-radius: 16px;
  background: black;
  align-items: flex-end;
  img{
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    align-self: center;
  }
}

.image-editor-footer-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 6px;
  gap: 24px;
}

@media screen and (max-width: 1280px) {
  div.modal-main, div.modal-content, div.modal-editor-container {
    min-width: 100%;
  }
  div.modal-dialog{
    margin-left: 0;
    margin-right: 0;
    max-width: 100%;
  }
}

.image-being-cropped{
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding: 12px;
}

@media screen and (max-width: 390px) {
  .image-being-cropped {
    max-width: 100%;
  }
}

.item{
  color: #EF6C00 !important;
  border-color: #EF6C00 !important;
}
.item:hover{
  color: #EF6C00 !important;
  border-color: #EF6C00 !important;
  background-color: rgb(251, 218, 191) !important;
}

.item-active{
  background-color: rgb(251, 218, 191) !important;
  border-color: rgb(251, 218, 191) !important;
  color: #EF6C00 !important;
}

.table-header {
  background: #fff;
  margin-bottom: 0.5rem;
}

.table-header tr th:first-child{
  border-radius: 1rem 0 0 1rem;
  background: #ECECEC;
  padding-left: 0.5rem;
}


.table-header tr th{
  padding: 0.5rem;
  background: #ECECEC;
  border-right: solid 1px #D5D5D5;
}

.table-header tr th:last-child{
  border-radius: 0 1rem 1rem 0;
  background: #ECECEC;
  padding-right: 0.5rem;
  border-right: none;
}

@media (max-width: 990px) {
  .card-header-hide-only-mobile {
    display: none !important;
  }
  .card-only-mobile {
    border-radius: 0.5rem;
    flex-direction: row-reverse !important;
    box-shadow: 0 8px 16px 0 #11111129;
    font-weight: 700;
    font-size: 14px;

  }
  .row-reverse-only-mobile {
    flex-direction: row-reverse !important;
  }
}
 
@media (max-width: 578px) {
  .image-editor-container-buttons-container .edit-button div:nth-child(2) {
    display: none;
  }
}

.header-components{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  width: 100%;
}


.header-text
{
  color: #FFF!important;
  font-family: Poppins, sans-serif;
  text-decoration: none;
} 

.font-weight-700{
  font-weight: 700!important;
}

.font-size-header{
  font-size: 32px!important;
}
.font-weight-400{
  font-weight: 400!important;
}

.image-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-radius: 32px 32px 0 0;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center center / cover no-repeat;
}

.rounded-container {
  border-radius: 32px!important;
  padding: 0!important;
}

@media screen and (max-width: 768px) {
  .font-size-header{
    font-size: 24px!important;
  }
}

.navbar-container {
  display: flex;
  height: 86px;
  padding: 12px 156px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EEE;
  background: #FFF;
}

.navbar-logo-container{
  display: flex;
  width: max-content;
  align-items: center;
  gap: 12px;
}

.navbar-logo{
  min-width: 32px;
  min-height: 32px
}

.navbar-logo-container-text-container{
  display: flex;
  max-width: 50%;
  height: -moz-fit-content;
  height: fit-content;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  color: #000303;
  font-family: Poppins, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.2px;
  text-wrap: wrap;
}

.navbar-buttons-container{
  display: flex;
  width: 30%;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
}
@media screen and (max-width: 1024px) {
  .navbar-logo-container-text-container{
    font-size: 12px;
    justify-content: flex-start;
    width: 60%;
  }
  .navbar-container{
    padding: 12px 25px;
  }
  .navbar-buttons-container{
    display: none
  }
}

.language-box-container {
  margin-top: 12px;
  position: absolute; 
  display: flex;
  padding: 24px 12px 24px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 32px;
  border: 1px solid var(--Greys-Grey-50, #EEE);
  background: #FFF;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);
}

.language-box-container-transition{
  opacity: 1;
  visibility: visible;
  transition: opacity 0.5s ease, visibility 0s;
}

.language-box-row {
  cursor: pointer;
  display: flex;
  height: 48px;
  padding: 8px 16px;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
}

.language-box-row-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.english-flag-bg {
  border-radius: 100%;
  background: var(--english-flag-icon) lightgray;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.romanian-flag-bg {
  border-radius: 100%;
  background: var(--romanian-flag-icon), lightgray 50% / cover no-repeat;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.language-selector-text{
  color: black;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 43px; /* 268.75% */
  letter-spacing: -0.16px;
}

.language-selector-text:hover
{
  transition: color 0.1s ease-in;
  color: #214BFF;
}

.mobile-dropdown-button{
  display: none;
  border-radius: 100%;
  width: 40px;
  height: 40px;
}

.mobile-dropdown-button:hover{
  background-color: rgba(187, 185, 183, 0.301);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.font-for-buttons {
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 22.4px */
}

.pgn-button {
  background: var(--Google-Material-Design-Amber-Amber-200, #FFE082);
  border-style: hidden;
  color: var(--Google-Material-Design-Deep-Orange-Deep-Orange-900, #BF360C);
}

.processImage-button {
  background: #DFF4DF;
  border-style: hidden;
  color: #00A800;
}

.processing-button {
  background: #e6f7e6;
  border-style: hidden;
  color: #00A800;
  cursor: default!important;
}

.pgn-button:hover {
  background: #E2BF54;
  color: #BF360C;
}

.processImage-button:hover {
  background: #A3F2A3;
  color: #00A800;
}

@media screen and (max-width: 1024px) {
  .mobile-dropdown-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .language-box-container{
    top: 60px;
    right: 25px;
  }
}

.height-box-pgn {
  height: 30vh
}

.pgn-box-container {
  display: flex;
  position: absolute; 
  padding: 10px!important;
  top: 5vh;
  z-index: 9999;
  height: -moz-fit-content;
  height: fit-content;
  max-height: 30vh;
  width: 20vw!important;
  max-width: 20vw;
  justify-content: center;
  text-align: justify;
  align-items: flex-start;
  border-radius: 10px;
  border: 1px solid var(--Greys-Grey-50, #EEE);
  background: #FFF;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);
}

.transition-visible{
  opacity: 1;
  visibility: visible; /* Make the element visible */
  transition: opacity 0.5s ease, visibility 0s;
}

@media screen and (min-width: 990px){
  .pgn-box-container {
    top: 7vh;
    right: 0vw!important;
  }
}
@media screen and (max-width: 990px){
  .width-50-xs-custom {
    width: 50%;
  }
  .pgn-box-container {
    top: 7vh;
    width: 60vw!important;
    max-width: 60vw!important;
  }
}

.clipboard-hover:hover {
  background-color: #d1cfcfb8;
  transition: background-color 0.5s ease;
}

.position-fixed-important{
  position: fixed!important;
}
@media screen and (max-width: 990px){
  div.container {
    display: flex;
    justify-content: center;
    max-width: 100%;
    width: 100%;
  }
  div.row {
    display: flex;
    padding: auto;
    max-width: 100%;
    width: 100%;
    --bs-gutter-x: 0; 
  }

  .container-fluid{
    --bs-gutter-x: 0; 
  }
}

#switchSizeLargeChecked {
  width: 60px;
  height: 30px;
  transition: background-position .15s ease-in-out;
  cursor: pointer;
}

.form-check-input:checked {
  background-color: #00A800!important;
  border-color: #EEE!important;
}
.form-check-input:focus {
  outline: none;
  border-color: #EEE!important;
}

.react-html5-camera-photo>video {
  width: 100%!important;
  border-radius: 10px;
  max-height: 50vh!important;
}

.modal-container-camera{
  display: flex;
  width: 50vw!important;
  padding: 24px 12px 36px 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  border-radius: 32px;
  background: #FFF;
  box-shadow: 0px 8px 16px 0px rgba(17, 17, 17, 0.32);
}

@media screen and (max-width: 1280px) {
  .modal-container-camera {
    width: 100vw!important;
  }
}

.camera-container{
  display: flex;
  justify-content: center;
  width: 100%;
  height: max-content!important;
  border-radius: 16px;
  padding: 10px 0px 0px 0px!important;
  background: black;
  align-items: center;
}

.pdf-image{
  width: 25px;
  height: 30px;
  border-radius: 10%;
}

.pdf-link-container {
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  justify-content: start;
  align-items: center;
  gap: 10px;
  color: #ff0101;
  font-family: Montserrat, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 43px; /* 268.75% */
  border-radius: 100px;
  background: #ff01011a;
  width: 100%;
  margin-bottom: 1rem;
  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);
  border: 2px solid #00010342;
  flex-wrap: nowrap;
}

.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}

.min-w-0 {
  min-width: 0;
}
.min-w-max {
  min-width: max-content;
}

.btn-half {
  height: 32px;
}

.bg-team {
  background-color: rgb(203,213,225, 0.8)!important;
  font-weight: 700;
  font-size: 18px;
  border: 0px 0px 5px 0px solid;
  border-color: rgb(148, 163, 184);
}

.bg-team:hover {
  background-color: rgb(203,213,225, 1)!important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,6DAAkF;EAClF,4DAAgF;EAChF,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,4CAA4C;EAC5C,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;;AAGA;EACE,YAAY;EACZ,cAAc;EACd,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,gBAAgB;AAClB;EACE;IACE,gBAAgB;EAClB;;AAEF;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,4BAAuB;EAAvB,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;AACtB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,sCAAsC;IACtC,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;;EAEjB;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;;AAGA;;EAEE,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,4JAAuJ;AACzJ;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,wBAAmB;EAAnB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,eAAe;IACf,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;IACE;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,sEAAsE;EACtE,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;;AAEA;EACE,kEAAkE;EAClE,oBAAoB;EACpB,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,mBAAmB,EAAE,6BAA6B;EAClD,4CAA4C;AAC9C;;AAEA;EACE;IACE,QAAQ;IACR,oBAAoB;EACtB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,QAAQ;IACR,qBAAqB;IACrB,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,WAAW;EACb;EACA;IACE,aAAa;IACb,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;EAC/B,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[":root{\n  --romanian-flag-icon: url('/src/Components/UploadButton/Assets/romanian-flag.png');\n  --english-flag-icon: url('/src/Components/UploadButton/Assets/english-flag.png');\n  --vertical-padding-button: 8px;\n}\n\nbody {\n  overflow: auto !important;\n}\n\nbody.modal-open {\n  overflow: hidden !important;\n}\n\n::-webkit-scrollbar {\n  width: 7px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 20%;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n  overflow: hidden !important;\n}\n\n.App {\n  text-align: center;\n  background: #EEE;\n}\n\n.background-white {\n  background: #FFF;\n}\n\n.background-gray {\n  background: #EEE;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.p-16 {\n  padding: 200px;\n}\n\n.rounded-image {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n}\n\n.disabledButton {\n  pointer-events: none;\n  border: 2px solid #BABABA!important;\n  background: #FFF!important;\n  color: #BABABA!important;\n}\n\n.button-upload {\n  display: flex;\n  border-style: hidden;\n  width: 100%;\n  padding: var(--vertical-padding-button) 24px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-shrink: 0;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  border-radius: 100px;\n}\n\n.button-upload-upload{\n  justify-content: center;\n  font-weight: 400;\n  background: #C7D2FF;\n  color: #214BFF;\n}\n\n.button-upload-upload:hover{\n  background: #93A8FF;\n  color: #002AE0;\n}\n\n.button-upload-view {\n  font-weight: 600;\n  color: #214BFF;\n  border: 2px solid #214BFF;\n  background: #FFF;\n}\n\n.button-upload-view:hover {\n  text-decoration-line: underline;\n}\n\n.x-button {\n  background: none;\n  border: none;\n  border-radius: 9999px;\n}\n\n.language-button {\n  display: flex;\n  height: 48px;\n  padding: var(--vertical-padding-button) 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  border: 2px solid #EEE;\n  background: #FFF;\n  color: #23233D;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 43px;\n  letter-spacing: -0.16px;\n}\n\n\n.selector {\n  height: 45px;\n  color: #EF6C00;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  border-radius: 50px;\n  line-height: 160%;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.selector-unselected:hover {\n  cursor: pointer;\n  font-weight: 600 ;\n  border: 2px solid #EF6C00;\n}\n\n.selector-unselected {\n  font-weight: 400;\n  border: 1px solid #EF6C00;\n  background: var(--Main-colors-White, #FFF);\n}\n\n.selector-selected{\n  background: #FBDABF;\n}\n\n.columnNameBox {\n  padding: 10px;\n  align-items: center;\n  min-width: 100px;\n  gap: 10px;\n  color: #4D4D68;\n  font-family: Poppins, sans-serif;\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.footer-button{\n  display: flex;\n  height: 56px;\n  min-width: 200px;\n  padding: 8px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  color: #FFF;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 43px; /* 268.75% */\n  border-radius: 100px;\n}\n\n/*Deals with footer button resizing*/\n@media screen and (max-width: 768px) {\n  .footer-button {\n    width: 100%;\n  }\n  .container-footer-button{\n    width: 100%;\n  }\n  .container-footer {\n    flex-direction: column;\n  }\n}\n\n.footer-button-pdf {\n  border-radius: 100px;\n  background: #214BFF;\n}\n\n.footer-button-pdf:hover {\n  background: #0028D4;\n}\n\n.footer-button-reimport {\n  border: 2px solid #0028D4;\n  background: #FFF;\n  color: #0028D4;\n}\n\n.footer-button-reimport:hover {\n  color: #FFF;\n  background: #0028D4;\n}\n\n.footer-button-reimport-disabled {\n  border: 2px solid #BABABA;\n  background: #FFF;\n  color: #BABABA;\n}\n\n.interaction-button {\n  display: flex;\n  width: 248px;\n  height: 48px;\n  padding: 8px 16px;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  gap: 12px;\n  flex-shrink: 0;\n  border-radius: 100px;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 43px; /* 268.75% */\n  border: 2px solid #214BFF;\n  background: #FFF;\n  color: #214BFF;\n}\n\n.interaction-button:hover {\n  color: #FFF;\n  background: #214BFF;\n  border-style: hidden;\n}\n\n.action-button {\n  display: flex;\n  height: 48px;\n  padding: var(--vertical-padding-button) 16px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  color: #FFF;\n  font-family: Montserrat, sans-serif;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  font-weight: 700;\n  border-radius: 100px;\n  border-style: hidden;\n}\n.action-button-save {\n  background: #214BFF;\n}\n.action-button-save:hover {\n  background: #0028D4;\n}\n\n.action-button-cancel {\n  background: #FF4047;\n}\n\n.action-button-cancel:hover{\n  background: #C70F16;\n}\n\n.login-button-logout {\n  display: inline-flex;\n  height: 48px;\n  padding: 8px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  color: #FFF;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 43px; /* 268.75% */\n  border-radius: 100px;\n  background: #214BFF;\n}\n\n.login-button-logout:hover {\n  background: #0028D4;\n}\n\n.edit-button {\n  display: flex;\n  padding: 4px 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  border-radius: 100px;\n  border: 1px solid #EEE;\n  background: #FFF;\n  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);\n  color: #214BFF;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.edit-button:hover {\n  background: #214BFF;\n  border-style: hidden;\n  color: #FFF;\n}\n\n.modal-container {\n  display: flex;\n  width: 35vw;\n  padding: 24px 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  border-radius: 32px;\n  background: #FFF;\n  box-shadow: 0 8px 16px 0 rgba(17, 17, 17, 0.32);\n}\n\n.modal-container-upload-area {\n  display: flex;\n  width: 94%;\n  height: auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 16px;\n  border: 3px dashed #D5D5D5;\n}\n\n.modal-container-header{ \n  display: flex;\n  width: 99%;\n  padding: 0 2rem;\n  justify-content: space-between;\n  align-items: center;\n  color: #23233D;\n  font-family: Poppins, sans-serif;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n@media screen and (max-width: 1280px) {\n  .modal-container {\n    width: 100%;\n  }\n  .modal-container-upload {\n    width: 90%;\n  }\n  .modal-container-header {\n    display: hidden;\n    border-style: hidden;\n    box-shadow: none;\n    border: 0;\n  }\n}\n\n/* To prevent weird outline from reactstrap modal. Overriding */\ndiv.modal-content, div.modal-main{\n  border-style: hidden;\n  box-shadow: none;\n}\n  div.modal-content{\n    background: none;\n  }\n\n.modal-container-drag-drop-info-second-container{\n  display: flex;\n  width: 248px;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n\n.modal-container-drag-drop-footer-text{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--Neutrals-Neutral-300, #6D6D82);\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 125%; /* 17.5px */\n}\n\n.modal-main{\n  min-width: max-content;\n}\n\n.modal-dialog{\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  position: relative!important;\n}\n\n.modal-editor-container {\n  display: flex;\n  flex-direction: column;\n  width: 60vw;\n  height: auto;\n  padding: 12px;\n  align-items: center;\n  border-radius: 32px;\n  background: #FFF;\n  box-shadow: 0 8px 16px 0 rgba(17, 17, 17, 0.32);\n}\n\n.image-editor-container-buttons-container{\n  display: flex;\n  width: 100%;\n  max-height:fit-content ;\n  padding: 0 24px 12px 24px;\n  justify-content: space-between;\n  position: absolute;\n}\n\n.image-editor-container{\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: 70vh;\n  border-radius: 16px;\n  background: black;\n  align-items: flex-end;\n  img{\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    align-self: center;\n  }\n}\n\n.image-editor-footer-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 6px;\n  gap: 24px;\n}\n\n@media screen and (max-width: 1280px) {\n  div.modal-main, div.modal-content, div.modal-editor-container {\n    min-width: 100%;\n  }\n  div.modal-dialog{\n    margin-left: 0;\n    margin-right: 0;\n    max-width: 100%;\n  }\n}\n\n.image-being-cropped{\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  padding: 12px;\n}\n\n@media screen and (max-width: 390px) {\n  .image-being-cropped {\n    max-width: 100%;\n  }\n}\n\n.item{\n  color: #EF6C00 !important;\n  border-color: #EF6C00 !important;\n}\n.item:hover{\n  color: #EF6C00 !important;\n  border-color: #EF6C00 !important;\n  background-color: rgb(251, 218, 191) !important;\n}\n\n.item-active{\n  background-color: rgb(251, 218, 191) !important;\n  border-color: rgb(251, 218, 191) !important;\n  color: #EF6C00 !important;\n}\n\n.table-header {\n  background: #fff;\n  margin-bottom: 0.5rem;\n}\n\n.table-header tr th:first-child{\n  border-radius: 1rem 0 0 1rem;\n  background: #ECECEC;\n  padding-left: 0.5rem;\n}\n\n\n.table-header tr th{\n  padding: 0.5rem;\n  background: #ECECEC;\n  border-right: solid 1px #D5D5D5;\n}\n\n.table-header tr th:last-child{\n  border-radius: 0 1rem 1rem 0;\n  background: #ECECEC;\n  padding-right: 0.5rem;\n  border-right: none;\n}\n\n@media (max-width: 990px) {\n  .card-header-hide-only-mobile {\n    display: none !important;\n  }\n  .card-only-mobile {\n    border-radius: 0.5rem;\n    flex-direction: row-reverse !important;\n    box-shadow: 0 8px 16px 0 #11111129;\n    font-weight: 700;\n    font-size: 14px;\n\n  }\n  .row-reverse-only-mobile {\n    flex-direction: row-reverse !important;\n  }\n}\n \n@media (max-width: 578px) {\n  .image-editor-container-buttons-container .edit-button div:nth-child(2) {\n    display: none;\n  }\n}\n\n.header-components{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  width: 100%;\n}\n\n\n.header-text\n{\n  color: #FFF!important;\n  font-family: Poppins, sans-serif;\n  text-decoration: none;\n} \n\n.font-weight-700{\n  font-weight: 700!important;\n}\n\n.font-size-header{\n  font-size: 32px!important;\n}\n.font-weight-400{\n  font-weight: 400!important;\n}\n\n.image-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  border-radius: 32px 32px 0 0;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url(\"/src/Assets/chessHeader.png\") center center / cover no-repeat;\n}\n\n.rounded-container {\n  border-radius: 32px!important;\n  padding: 0!important;\n}\n\n@media screen and (max-width: 768px) {\n  .font-size-header{\n    font-size: 24px!important;\n  }\n}\n\n.navbar-container {\n  display: flex;\n  height: 86px;\n  padding: 12px 156px;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #EEE;\n  background: #FFF;\n}\n\n.navbar-logo-container{\n  display: flex;\n  width: max-content;\n  align-items: center;\n  gap: 12px;\n}\n\n.navbar-logo{\n  min-width: 32px;\n  min-height: 32px\n}\n\n.navbar-logo-container-text-container{\n  display: flex;\n  max-width: 50%;\n  height: fit-content;\n  flex-direction: column;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #000303;\n  font-family: Poppins, sans-serif;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.2px;\n  text-wrap: wrap;\n}\n\n.navbar-buttons-container{\n  display: flex;\n  width: 30%;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 24px;\n}\n@media screen and (max-width: 1024px) {\n  .navbar-logo-container-text-container{\n    font-size: 12px;\n    justify-content: flex-start;\n    width: 60%;\n  }\n  .navbar-container{\n    padding: 12px 25px;\n  }\n  .navbar-buttons-container{\n    display: none\n  }\n}\n\n.language-box-container {\n  margin-top: 12px;\n  position: absolute; \n  display: flex;\n  padding: 24px 12px 24px 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  border-radius: 32px;\n  border: 1px solid var(--Greys-Grey-50, #EEE);\n  background: #FFF;\n  opacity: 0;\n  visibility: hidden;\n  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);\n}\n\n.language-box-container-transition{\n  opacity: 1;\n  visibility: visible;\n  transition: opacity 0.5s ease, visibility 0s;\n}\n\n.language-box-row {\n  cursor: pointer;\n  display: flex;\n  height: 48px;\n  padding: 8px 16px;\n  align-items: center;\n  gap: 12px;\n  border-radius: 12px;\n}\n\n.language-box-row-icon {\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.english-flag-bg {\n  border-radius: 100%;\n  background: var(--english-flag-icon) lightgray;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.romanian-flag-bg {\n  border-radius: 100%;\n  background: var(--romanian-flag-icon), lightgray 50% / cover no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.language-selector-text{\n  color: black;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 43px; /* 268.75% */\n  letter-spacing: -0.16px;\n}\n\n.language-selector-text:hover\n{\n  transition: color 0.1s ease-in;\n  color: #214BFF;\n}\n\n.mobile-dropdown-button{\n  display: none;\n  border-radius: 100%;\n  width: 40px;\n  height: 40px;\n}\n\n.mobile-dropdown-button:hover{\n  background-color: rgba(187, 185, 183, 0.301);\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.font-for-buttons {\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%; /* 22.4px */\n}\n\n.pgn-button {\n  background: var(--Google-Material-Design-Amber-Amber-200, #FFE082);\n  border-style: hidden;\n  color: var(--Google-Material-Design-Deep-Orange-Deep-Orange-900, #BF360C);\n}\n\n.processImage-button {\n  background: #DFF4DF;\n  border-style: hidden;\n  color: #00A800;\n}\n\n.processing-button {\n  background: #e6f7e6;\n  border-style: hidden;\n  color: #00A800;\n  cursor: default!important;\n}\n\n.pgn-button:hover {\n  background: #E2BF54;\n  color: #BF360C;\n}\n\n.processImage-button:hover {\n  background: #A3F2A3;\n  color: #00A800;\n}\n\n@media screen and (max-width: 1024px) {\n  .mobile-dropdown-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .language-box-container{\n    top: 60px;\n    right: 25px;\n  }\n}\n\n.height-box-pgn {\n  height: 30vh\n}\n\n.pgn-box-container {\n  display: flex;\n  position: absolute; \n  padding: 10px!important;\n  top: 5vh;\n  z-index: 9999;\n  height: fit-content;\n  max-height: 30vh;\n  width: 20vw!important;\n  max-width: 20vw;\n  justify-content: center;\n  text-align: justify;\n  align-items: flex-start;\n  border-radius: 10px;\n  border: 1px solid var(--Greys-Grey-50, #EEE);\n  background: #FFF;\n  opacity: 0;\n  visibility: hidden;\n  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);\n}\n\n.transition-visible{\n  opacity: 1;\n  visibility: visible; /* Make the element visible */\n  transition: opacity 0.5s ease, visibility 0s;\n}\n\n@media screen and (min-width: 990px){\n  .pgn-box-container {\n    top: 7vh;\n    right: 0vw!important;\n  }\n}\n@media screen and (max-width: 990px){\n  .width-50-xs-custom {\n    width: 50%;\n  }\n  .pgn-box-container {\n    top: 7vh;\n    width: 60vw!important;\n    max-width: 60vw!important;\n  }\n}\n\n.clipboard-hover:hover {\n  background-color: #d1cfcfb8;\n  transition: background-color 0.5s ease;\n}\n\n.position-fixed-important{\n  position: fixed!important;\n}\n@media screen and (max-width: 990px){\n  div.container {\n    display: flex;\n    justify-content: center;\n    max-width: 100%;\n    width: 100%;\n  }\n  div.row {\n    display: flex;\n    padding: auto;\n    max-width: 100%;\n    width: 100%;\n    --bs-gutter-x: 0; \n  }\n\n  .container-fluid{\n    --bs-gutter-x: 0; \n  }\n}\n\n#switchSizeLargeChecked {\n  width: 60px;\n  height: 30px;\n  transition: background-position .15s ease-in-out;\n  cursor: pointer;\n}\n\n.form-check-input:checked {\n  background-color: #00A800!important;\n  border-color: #EEE!important;\n}\n.form-check-input:focus {\n  outline: none;\n  border-color: #EEE!important;\n}\n\n.react-html5-camera-photo>video {\n  width: 100%!important;\n  border-radius: 10px;\n  max-height: 50vh!important;\n}\n\n.modal-container-camera{\n  display: flex;\n  width: 50vw!important;\n  padding: 24px 12px 36px 12px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 32px;\n  border-radius: 32px;\n  background: #FFF;\n  box-shadow: 0px 8px 16px 0px rgba(17, 17, 17, 0.32);\n}\n\n@media screen and (max-width: 1280px) {\n  .modal-container-camera {\n    width: 100vw!important;\n  }\n}\n\n.camera-container{\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  height: max-content!important;\n  border-radius: 16px;\n  padding: 10px 0px 0px 0px!important;\n  background: black;\n  align-items: center;\n}\n\n.pdf-image{\n  width: 25px;\n  height: 30px;\n  border-radius: 10%;\n}\n\n.pdf-link-container {\n  display: flex;\n  flex-direction: row;\n  padding: 8px 16px;\n  justify-content: start;\n  align-items: center;\n  gap: 10px;\n  color: #ff0101;\n  font-family: Montserrat, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 43px; /* 268.75% */\n  border-radius: 100px;\n  background: #ff01011a;\n  width: 100%;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 4px 0 rgba(17, 17, 17, 0.24);\n  border: 2px solid #00010342;\n  flex-wrap: nowrap;\n}\n\n.text-ellipsis {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.min-w-0 {\n  min-width: 0;\n}\n.min-w-max {\n  min-width: max-content;\n}\n\n.btn-half {\n  height: 32px;\n}\n\n.bg-team {\n  background-color: rgb(203,213,225, 0.8)!important;\n  font-weight: 700;\n  font-size: 18px;\n  border: 0px 0px 5px 0px solid;\n  border-color: rgb(148, 163, 184);\n}\n\n.bg-team:hover {\n  background-color: rgb(203,213,225, 1)!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
